import { makeStyles } from '@material-ui/core';

import { neutral } from '../../shared/styles/colors';

export default makeStyles({
  body: {
    width: '100%',
    backgroundColor: neutral.white,
  },
  root: {
    border: `1px solid ${neutral['20']}`,
    padding: '0.75rem 0.5rem',
    borderRadius: '0.5rem',
    display: 'grid',
    gap: '0.5rem',
  },
  titleWrapper: {
    borderBottom: `1px solid ${neutral['20']}`,
    paddingBottom: '0.5rem',
  },
  title: {
    color: neutral['80'],
    fontSize: '0.625rem',
    fontFamily: 'PP Object Sans',
    fontWeight: 'bold',
    letterSpacing: '1px',
    lineHeight: 'normal',
    textTransform: 'uppercase',
  },
});
